export const annotationHasValue = (annotation: Annotation) => {
  return (
    annotation.ground_truth_float_value !== null ||
    annotation.ground_truth_string_value !== null ||
    annotation.ground_truth_set_value !== null
  )
}

export type AnnotationPriority = "PRIMARY" | "STANDARD"

export type AnnotationDetails = Record<string, unknown> & {
  custom_explanation?: string | null
}

export interface Annotation {
  id: string
  project_annotation_id?: string | null
  simulation_output_id: string
  assignee: string
  metric_id: string | null
  ground_truth_float_value: number | null
  ground_truth_string_value: string | null
  ground_truth_set_value: string[] | null
  ground_truth_json: Record<string, unknown> | null
  ground_truth_subvalues_by_timestamp: unknown[] | null
  annotations: AnnotationDetails | null
  archived: boolean
  created_at: string
  last_updated_at: string
  priority: AnnotationPriority
}
